var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdc77c",
    d: "M187 87.3c0-10-8.1-18.1-18.1-18.1H20.1C10.1 69.3 2 77.4 2 87.3v337.3c0 10 8.1 18.1 18.1 18.1h400.7c10 0 18.1-8.1 18.1-18.1V123.5c0-10-8.1-18.1-18.1-18.1H205.1c-10 0-18.1-8.1-18.1-18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbd984",
    d: "M420.8 105.4H205.1c-10 0-18.1-8.1-18.1-18.1s-8-18-18-18H20.1c-10 0-18.1 8.1-18.1 18v9.2c0-10 8.1-18.1 18.1-18.1H169c10 0 18.1 8.1 18.1 18.1s8.1 18.1 18.1 18.1h215.7c10 0 18.1 8.1 18.1 18.1v-9.2c-.1-10-8.2-18.1-18.2-18.1zM326.6 169.6l.1-.3c2.3-8.1 9.8-13.8 18.1-13.8h147.8c11.7 0 19.9 11 16.7 22.4l-71.4 251c-2.3 8.1-9.8 13.8-18.1 13.8H20.2c-11.7 0-19.9-11-16.7-22.4L67 197.1c2.3-8.1 9.8-13.8 18.1-13.8h223.5c8.2.1 15.7-5.6 18-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe4a9",
    d: "M3.4 428.2 66.9 205c2.3-8.1 9.8-13.8 18.1-13.8h223.5c8.3 0 15.8-5.7 18.1-13.8l.1-.3c2.3-8.1 9.8-13.8 18.1-13.8h147.8c8.5 0 15.1 5.8 16.9 13.4 2.4-11-5.6-21.2-16.9-21.2H344.8c-8.3 0-15.8 5.7-18.1 13.8l-.1.3c-2.3 8.1-9.8 13.8-18.1 13.8H85c-8.3 0-15.8 5.7-18.1 13.8L3.4 420.4c-.9 3.1-.9 6.2-.2 9 .1-.4.1-.8.2-1.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folderIcon.b105ba787b2578fa15156c69e88183fb.svg";
export { ForwardRef as ReactComponent };